
import { ResultData, ValidateResult } from "@nt-portal/common-sdk";
import { KeywordIndex, KeywordIndexDataService } from "@nt-portal/doc-agent-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";


export interface KeywordIndexOptions extends ControllerOptions<KeywordIndex> {
    tags?: string[];
    url?: string;
}

export const initKeywordIndex = () => {
    let item: KeywordIndex = {
        name: "",
        createdBy: ""
    }
    return item;
}

export const createKeywordIndex = (item: Partial<KeywordIndex>): KeywordIndex => {
    return {
        id: item.id ?? "",
        name: item.name ?? "",
        createdBy: item.createdBy ?? ""
    }
}


export class ClientKeywordIndexService extends BaseClientService implements DataController<KeywordIndex> {

    private _service: KeywordIndexDataService;

    constructor() {
        super();
        this._service = new KeywordIndexDataService({
            apiService: this.apiService,
            url: this.settings.docChatServer
        });
    }

    public async get(options: KeywordIndexOptions): Promise<ResultData<KeywordIndex>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);

    }
    public async getLookup(options: KeywordIndexOptions): Promise<ResultData<KeywordIndex>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: KeywordIndexOptions): Promise<KeywordIndex | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: KeywordIndexOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: KeywordIndexOptions): Promise<KeywordIndex | KeywordIndex[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: KeywordIndexOptions): Promise<KeywordIndex | KeywordIndex[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }
    public async import(options: KeywordIndexOptions): Promise<any> {
        if (options.file)
            return await this._service.import(this.token, options.file);
    }

    public async export(options: KeywordIndexOptions): Promise<any> {
        return await this._service.export(this.token, options.filter);
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult | null> {
        return await this._service.validateName(name, this.token, id, "")
    }

}